export function createRoutes() {
  return [
    {
      path: 'custom-links',
      component: () => import(/* webpackChunkName: "customLinkChrome" */ '@/customLinks/CustomLinkChrome.vue'),
      children: [
        {
          path: '/',
          name: 'customLinkList',
          component: () => import(/* webpackChunkName: "customLinkList" */ '@/customLinks/CustomLinkList.vue'),
        },
        {
          path: 'create',
          components: {
            default: () => import(/* webpackChunkName: "customLinkList" */ '@/customLinks/CustomLinkList.vue'),
            createCustomLink: () => import(/* webpackChunkName: "createCustomLinksModal" */ '@/customLinks/CreateCustomLinksModal.vue'),
          },
        },
        {
          path: 'edit/:id',
          components: {
            default: () => import(/* webpackChunkName: "customLinkList" */ '@/customLinks/CustomLinkList.vue'),
            editCustomLink: () => import(/* webpackChunkName: "EditCustomLinkModal" */ '@/customLinks/EditCustomLinkModal.vue'),
          },
        },
      ],
    },
  ];
}

export default {
  createRoutes,
};
